import { useHandleResponse } from '@/utils/useHandleResponse';
import { useMutation } from '@tanstack/react-query';
import { App, Button, Col, Divider, Form, Input, InputNumber, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField, updateProps } from '../../../contextRedux/TimeKeeperEmployer/TimeKeeperEmployerModel';
import TimeKeeperEmployerService from '../../../services/timeKeeperEmployer/TimeKeeperEmployerService';
import { RootState } from '../../../store';
import useWindowSize from '../../../utils/useWindowSize';

const TimeKeeperEmployerForm: FC<any> = () => {
  const [form] = useForm();
  const { message } = App.useApp();
  const handleResponse = useHandleResponse();
  const dispatch = useDispatch();
  const width = useWindowSize();

  const timeKeeperEmployer = useSelector((state: RootState) => state.models.timeKeeperEmployer);

  const initialValues = {
    id: useSelector((state: RootState) => state?.models?.timeKeeperEmployer?.id),
    name: useSelector((state: RootState) => state?.models?.timeKeeperEmployer?.name),
    reference: useSelector((state: RootState) => state?.models?.timeKeeperEmployer?.reference),
  };

  const onSaveTimeKeeperEmployer = async () => {
    saveLaborType(timeKeeperEmployer);
  };

  const { mutate: saveLaborType, isPending: _isSavingLabor } = useMutation({
    mutationFn: (formData: any) => TimeKeeperEmployerService.upsert(timeKeeperEmployer.id, formData),
    onSuccess: (data: any) => {
      if (data) {
        handleResponse(data, data?.response?.name);
        dispatch(updateProps({ field: 'isModalVisible', value: false }));
        dispatch(updateProps({ field: 'refresh', value: !timeKeeperEmployer.props.refresh }));
      }
    },
    onError: (error: any) => {
      message.error(error.message);
    },
  });

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  useEffect(() => {
    form.setFieldsValue(timeKeeperEmployer);
  }, [timeKeeperEmployer]);

  return (
    <Form
      form={form}
      name='timeKeeperEmployerForm'
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      onFinish={onSaveTimeKeeperEmployer}
      layout='vertical'
    >
      <Divider />
      <Row gutter={[16, 16]} className='row'>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Denumire' name='name' rules={[{ required: true, message: 'Introdu denumire!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Referinta' name='reference' rules={[{ required: true, message: 'Introdu referinta!' }]}>
            <InputNumber />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button type='primary' htmlType='submit'>
          Finalizare
        </Button>
      </Form.Item>
    </Form>
  );
};

export default TimeKeeperEmployerForm;
